import React from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import throttle from 'lodash/throttle'

import { transmit, gtmPush } from 'actions/naughtyActions'
import { shouldTrack, shouldTrackGTM } from 'selectors/authSelectors'
import { getGTMPayload } from 'selectors/naughtySelectors'

export class Naughty extends React.Component {
  constructor(...args) {
    super(...args)

    this.gtmPush = throttle(() => this.props.gtmPush(this.props.gtmPayload), 1)
  }

  componentDidUpdate(prevProps) {
    let { shouldTrackGTM, gtmPayload } = this.props

    if (
      shouldTrackGTM &&
      !isEmpty(gtmPayload) &&
      get(gtmPayload, 'VIN') &&
      !isEqual(prevProps.gtmPayload, gtmPayload)
    )
      this.gtmPush()
  }

  componentDidMount() {
    let { transmit, shouldTrack } = this.props

    if (!shouldTrack) return

    transmit()
    window.addEventListener('beforeunload', transmit)
  }

  render() {
    return null
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    shouldTrack: shouldTrack(state),
    shouldTrackGTM: shouldTrackGTM(state),
    gtmPayload: getGTMPayload(state),
  }
}

export default connect(
  mapStateToProps,
  { transmit, gtmPush },
)(Naughty)
